import debounce from 'lodash/debounce';
import React, { useState } from 'react';
import { Filter } from 'react-table';

interface DefaultFilterProps {
  filter?: Filter;
  onChange: (value: string) => void;
  placeholder?: string;
}

const isString = (_value: any) => Boolean(typeof _value === 'string');
const isNumber = (_value: any) => Boolean(typeof _value === 'number');

const getRowValue = (value: any) => {
  if (!value || (!isString(value) && !isNumber(value))) return false;
  return value.toString().toLowerCase();
};

export const defaultFilterMethod = (filter: Filter, row: any) => {
  const isArrayWithoutValues = (element: any) =>
    element && typeof element === 'object' && element.constructor === Array && element.length === 0;
  if (isArrayWithoutValues(filter.value)) return true;
  if (!filter.value) return false;
  const isFilteringPivotedColumns = Boolean(row._aggregated);
  const rowValue = getRowValue(row[filter.id]);
  if (rowValue && !isFilteringPivotedColumns) {
    return rowValue.includes(filter.value.toLowerCase());
  }
  // This enable us to filter by pivoted rows
  if (isFilteringPivotedColumns) {
    return row._subRows.filter((subrow: any) => {
      const subRowValue = getRowValue(subrow[filter.id]);
      return subRowValue && subRowValue.includes(filter.value.toLowerCase());
    });
  }
  return false;
};

const DefaultFilter: React.FC<DefaultFilterProps> = ({ onChange, placeholder, filter }) => {
  const [value, setValue] = useState(filter ? filter.value : '');
  const onInputValueChange = debounce((_value: string) => onChange(_value), 300);

  return (
    <input
      style={{ width: '100%' }}
      type="text"
      data-testid="default-filter-input"
      placeholder={placeholder}
      value={value}
      onChange={event => {
        setValue(event.target.value);
        onInputValueChange(event.target.value);
      }}
    />
  );
};

export default DefaultFilter;
